(ns frontend.ui.component.lp-portal.report.company.net-debt-chart.controller
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.chart.utils :as chart-utils]))

(defn config->editable-data
  [config]
  {:chart-key :net-debt
   :columns (some->> config
                     :xAxis
                     (mapcat :categories)
                     (vec))
   :data    (->> config
                 :series
                 (mapv (fn [serie]
                         (vec (concat [(:name serie)]
                                      (:data serie))))))
   :y-axis-config (chart-utils/config->editable-y-axis-data config)
   :tooltip-config (chart-utils/config->editable-tooltip-data config)})

(defn editable-data->raw-data
  [edited-data]
  (let [hardcoded-keys [:net-debt :net-debt-by-ebitda-ltm]]
    (merge {:labels (:columns edited-data)}
           {:series-names (mapv first (:data edited-data))}
           (->> edited-data
                :data
                (map-indexed (fn [idx row]
                               (let [number-data (->> row
                                                      rest
                                                      (map (fn [item]
                                                             (when (number? item) item)))
                                                      vec)]
                                 (if-let [key (get hardcoded-keys idx)]
                                   [key number-data]
                                   (js/console.warn "Cannot resolve data " row)))))
                (into {})))))

(defn company-net-debt
  [{:keys [labels net-debt net-debt-by-ebitda-ltm y-axis-config tooltip-config series-names]}]
  (let [y-axis-1 (chart-utils/resolve-editable-axis-data (first y-axis-config) chart-utils/axis-meur-formatter-no-division "Net debt")
        y-axis-2 (chart-utils/resolve-editable-axis-data (second y-axis-config) chart-utils/axis-mult-formatter "Net debt / EBITDA")
        tooltip-1 (chart-utils/resolve-editable-tooltip-data (first tooltip-config) chart-utils/meur-formatter)
        tooltip-2 (chart-utils/resolve-editable-tooltip-data (second tooltip-config) chart-utils/mult-formatter)
        series-name-1 (chart-utils/resolve-series-name (first series-names) "Net debt")
        series-name-2 (chart-utils/resolve-series-name (second series-names) "Net debt / EBITDA")]
  {:chart       {:zoomType "xy"}
   :xAxis       [{:categories    labels
                  :lineColor     (theme/color [:chart :x-axis :line])
                  :gridLineColor (theme/color [:chart :x-axis :grid-line])}]
   :yAxis       [{:title         {:text (:title-text y-axis-1)}
                  :softMin       0
                  :softMax       0
                  :labels        {:formatter     (:formatter-fn y-axis-1)}
                  :lineColor     (theme/color [:chart :y-axis :line])
                  :gridLineColor (theme/color [:chart :y-axis :grid-line])}
                 {:title         {:text (:title-text y-axis-2)}
                  :opposite      true
                  :softMin       0
                  :softMax       0
                  :labels        {:formatter     (:formatter-fn y-axis-2)}
                  :lineColor     (theme/color [:chart :y-axis :line])
                  :gridLineColor (theme/color [:chart :y-axis :grid-line])
                 }]
   :colors       (or (util/custom-colors)
                     (util/gradient-colors [:lp-report :chart :bar :gradient-start]
                                      [:lp-report :chart :bar :gradient-end]
                                      2))
   :tooltip     {:outside         true
                 :useHtml         true
                 :backgroundColor (theme/color [:page-bg :bg])
                 :style           {:opacity         1
                                   :backgroundColor (theme/color [:page-bg :bg])}
                 :shared          true}
   :plotOptions {:line {:marker {:enabled false}}}
   :series      [{:name    series-name-1
                  :type    "column"
                  :data    net-debt
                  :tooltip {:outside         true
                            :useHtml         true
                            :backgroundColor (theme/color [:page-bg :bg])
                            :style           {:opacity         1
                                              :backgroundColor (theme/color [:page-bg :bg])}
                            :pointFormatter  (:formatter-fn tooltip-1)}}
                 {:name    series-name-2
                  :type    "line"
                  :data    net-debt-by-ebitda-ltm
                  :yAxis   1
                  :tooltip {:outside         true
                            :useHtml         true
                            :backgroundColor (theme/color [:page-bg :bg])
                            :style           {:opacity         1
                                              :backgroundColor (theme/color [:page-bg :bg])}
                            :pointFormatter  (:formatter-fn tooltip-2)}}]}))
